class VideoLoop extends HTMLElement {
  connectedCallback() {
    this.poster = this.querySelector('.video-loop__poster');
    this.media = this.querySelector('.video-loop__media');
    this.videoDesktop = this.querySelector('.video-loop__video--desktop');
    this.videoMobile = this.querySelector('.video-loop__video--mobile');
    this.mql = window.matchMedia('(max-width: 575px)');
    this.inView = false;

    this.onBreakpointChange = this.onBreakpointChange.bind(this);
    this.mql.addEventListener('change', this.onBreakpointChange);

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          this.inView = entry.isIntersecting;
          if (entry.isIntersecting) {
            this.playCurrentVideo();
          } else {
            this.pauseAllVideos();
          }
        });
      },
      { threshold: 0.5 }
    );

    if (this.media) this.observer.observe(this.media);
  }

  disconnectedCallback() {
    this.mql.removeEventListener('change', this.onBreakpointChange);
    if (this.observer) this.observer.disconnect();
  }

  getActiveVideo() {
    return this.mql.matches ? this.videoMobile : this.videoDesktop;
  }

  getInactiveVideo() {
    return this.mql.matches ? this.videoDesktop : this.videoMobile;
  }

  playCurrentVideo() {
    const active = this.getActiveVideo();
    const inactive = this.getInactiveVideo();

    if (inactive) inactive.pause();

    if (!active) return;

    active.play().then(() => {
      this.hidePoster();
    }).catch(() => {});
  }

  pauseAllVideos() {
    if (this.videoDesktop) this.videoDesktop.pause();
    if (this.videoMobile) this.videoMobile.pause();
  }

  hidePoster() {
    if (this.poster) {
      this.poster.classList.add('video-loop__poster--hidden');
    }
  }

  onBreakpointChange() {
    const active = this.getActiveVideo();
    const inactive = this.getInactiveVideo();

    if (inactive) inactive.pause();

    if (this.inView && active) {
      active.play().then(() => {
        this.hidePoster();
      }).catch(() => {});
    }
  }
}

customElements.define('video-loop', VideoLoop);
